import * as CUTIL from "@utils/commUtils";
import { useEffect } from "react";
export const handleClickOutside = (e, setRecoilSettingPopup, setRecoilUserInfoPopup, setRecoilAlarmPopup) => {
    let modalTag = document.querySelector(".dimm");
    let isModal = !CUTIL.isnull(modalTag) ? modalTag.style.display === "block" : false;
    if (isModal)
        return;
    const clickTag = e.target;
    let isHeaderArea = false;
    let headerBtnArea = clickTag.closest(".header__etc");
    let headerUserTag = clickTag.closest(".header__userinfo");
    let headerAlarmTag = clickTag.closest(".header__alarm");
    let headerSettingTag = clickTag.closest(".header__setting");
    if (!CUTIL.isnull(headerBtnArea))
        isHeaderArea = true;
    if (!CUTIL.isnull(headerUserTag))
        isHeaderArea = true;
    if (!CUTIL.isnull(headerAlarmTag))
        isHeaderArea = true;
    if (!CUTIL.isnull(headerSettingTag))
        isHeaderArea = true;
    if (!isHeaderArea) {
        setRecoilSettingPopup(false);
        setRecoilUserInfoPopup(false);
        if (setRecoilAlarmPopup)
            setRecoilAlarmPopup(false); // toggle
    }
};
//팝업 close 버튼 클릭
export const closeBtn = (popBody) => {
    if (popBody && popBody.props && popBody.props.htmlClose)
        return popBody.props.htmlClose;
    return null;
};
//팝업 className 수정
export const updateClassName = (popBody) => {
    if (popBody && popBody.props && popBody.props.htmlClass)
        return popBody.props.htmlClass;
    return null;
};
//외부 클릭 감지 시 닫힘
export const useOnClickOutside = (ref, handler) => {
    useEffect(() => {
        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener); // 모바일 기기 고려
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]);
};
